import { styled, useTheme } from '@mui/material/styles';
import { Box, Button, Dialog, DialogContent, Link as MuiLink, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import ErrorWarningFillIcon from 'remixicon-react/ErrorWarningFillIcon';
import GrowDialogTransition from 'components/modal/GrowDialogTransition';

type DomainNotRegisteredModalProps = {
  email: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

function DomainNotRegisteredModal({ email, open, setOpen }: DomainNotRegisteredModalProps) {
  const theme = useTheme();

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      sx={{ '& .MuiPaper-root': { borderRadius: '16px' } }}
      TransitionComponent={GrowDialogTransition}
    >
      <DialogContent id="dialog-description">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          py={2}
        >
          <ErrorWarningFillIcon size={80} color={theme.palette.custom.superNova} />
          <Note sx={{ mt: 3 }}>
            Your domain{' '}
            <Typography
              component="strong"
              sx={(theme) => ({ color: theme.palette.custom.redWine, fontWeight: 600 })}
            >
              {email?.split('@')?.[1]}
            </Typography>{' '}
            is not registered in BuildWise.
          </Note>
          {/* <Note>
            Please contact <Link href="mailto:support@buildwise.ai">support@buildwise.ai</Link> for
            assistance.
          </Note> */}
          <br />
          <Box>
            <Link href="mailto:support@buildwise.ai">
              <Button
                variant="outlined"
                sx={(theme) => ({
                  minWidth: 180,
                  borderRadius: '8px',
                  mr: 1,
                  borderColor: theme.palette.custom.coolGrey,
                })}
              >
                Contact Support
              </Button>
            </Link>
            <Button
              variant="contained"
              onClick={closeModal}
              sx={{ minWidth: 180, borderRadius: '8px' }}
            >
              Dismiss
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

const Note = styled(Typography, { label: 'Note' })(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.custom.mirage,
  margin: '4px 0',
}));

const Link = styled(MuiLink, { label: 'Link' })(({ theme }) => ({
  textDecoration: 'underline',
  fontWeight: 700,
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.custom.link,
  },
}));

export default DomainNotRegisteredModal;
